/** Informations légales Atout Web — source : CGV boutique.webtarot.fr + registre */
export const LEGAL = {
  companyLegalName: 'ATOUT WEB',
  companyForm: 'SARL',
  companyName: 'ATOUT WEB SARL',
  siret: '48200211000013',
  rcs: 'Paris',
  manager: 'Nicolas TRANIC',
  /** Pas de délégué à la protection des données (DPO) désigné */
  hasDpo: false,
  brand: 'Webtarot',
  appName: 'Webtarot Neo',
  appUrl: 'https://neo.webtarot.fr',
  mainSiteUrl: 'https://www.webtarot.fr',
  registeredOffice: '68 boulevard Port-Royal, 75005 Paris, France',
  contactEmail: 'assistance@webtarot.fr',
  ethicsUrl: 'https://www.webtarot.fr/site/os/communaute/ethique.php',
  hoster: {
    name: 'OVH SAS',
    address: '2 rue Kellermann, 59100 Roubaix, France',
  },
  dataDeletionInstructionsUrl: 'https://neo.webtarot.fr/confidentialite#suppression-donnees',
  dataDeletionStatusUrl: 'https://neo.webtarot.fr/suppression-donnees',
  lastUpdated: 'mai 2026',
} as const;
